import {
  getCloudProject,
  listCloudProjects,
  type ThesisCloudProjectMeta,
} from '@/lib/thesisCloudApi'
import { applyThesisCloudPayload } from '@/lib/thesisCloudBundle'
import { setCloudBinding } from '@/lib/thesisCloudMap'

/** 把云端一篇整包落到本机 IndexedDB，并写绑定 */
export async function restoreCloudProjectToLocal(projectId: string): Promise<
  | { ok: true; localNovelId: string; title: string }
  | { ok: false; error: string }
> {
  const r = await getCloudProject(projectId)
  if (!r.ok) return { ok: false, error: r.error || '拉取失败' }
  const localNovelId = r.data.localNovelId
  if (!localNovelId) return { ok: false, error: '云端记录缺少本机 ID' }
  if (!r.data.payload) return { ok: false, error: '云端包为空' }

  const applied = await applyThesisCloudPayload(localNovelId, r.data.payload)
  if (!applied.ok) return { ok: false, error: applied.error }

  setCloudBinding(localNovelId, {
    projectId: r.data.id,
    clientVersion: r.data.clientVersion,
    updatedAt: r.data.updatedAt,
  })
  return { ok: true, localNovelId, title: r.data.title || '未命名论文' }
}

export async function fetchCloudProjectList(): Promise<
  | { ok: true; projects: ThesisCloudProjectMeta[] }
  | { ok: false; error: string }
> {
  const r = await listCloudProjects()
  if (!r.ok) return { ok: false, error: r.error || '无法列出云端论文' }
  return { ok: true, projects: r.data.projects || [] }
}
